import * as types from '../constants/actionTypes';
import initialState from './initialState';
import * as videoRequestType from '../constants/videoRequestType';
import {CALL_STATE} from '../constants/constants';

export default function videoCallReducer(state = initialState.videoCall, action) {
  switch (action.type) {
    case types.UPDATE_LIST_VIDEO_DEVICES: {
      return state.set('videoDevices', action.data);
    }
    case types.SWITCH_CARD_VIDEO_VIEW: {
      return state.set('switchedView', !!action.data);
    }
    case types.UPDATE_WINDOW_CALL_TYPE: {
      return state.set('windowCallType', action.data);
    }
    case types.UPDATE_RECEIVING_CALL_TYPE: {
      return state.set('receivingCallType', action.data);
    }
    case types.UPDATE_MUTED: {
      return state.set('isMuted', !!action.data);
    }
    case types.UPDATE_CAMERA_MODE: {
      return state.set('cameraMode', action.data);
    }
    case types.UPDATE_MIC: {
      return state.set('disableMic', !!action.data);
    }
    case types.UPDATE_VOICE_CALL: {
      return state.set('voiceCall', !!action.data);
    }
    case types.UPDATE_VOICE_CALL_PEER_USER: {
      return state.set('voiceCallPeerUser', !!action.data);
    }
    case types.UPDATE_STARTER: {
      return state.set('isStarter', !!action.data);
    }
    case types.UPDATE_STATE_CALL: {
      return state.set('callState', action.data);
    }
    case types.SET_LOCAL_STREAM_SUCCESS: {
      state = state.set('callWindow', action.data.callWindow);
      state = state.set('callModal', action.data.callModal);
      if (action && action.data && action.data.friendID) {
        state = state.set('friendID', action.data.friendID).set('preFriendID', action.data.friendID);
      }
      return state.set('localSrc', action.data.localSrc);
    }

    case types.SET_FRIEND_ID: {
      return state.set('friendID', action.data.friendID).set('preFriendID', action.data.friendID);
    }

    case types.UPDATE_VIDEO_CALL_STATE: {
      console.log('action', action.data);
      return state.merge(action.data);
    }

    case types.CHANGE_STATUS_VIDEO_CALL_WINDOW: {
      return state.set('callWindow', action.data.callWindow);
    }

    case types.SET_PEER_STREAM_SUCCESS: {
      return state.set('peerSrc', action.data.peerSrc);
    }

    case types.SHOW_LOCAL_PHOTO_SUCCESS: {
      return state.set('showUserPhoto', action.data.showLocalPhoto);
    }

    case types.SHOW_PEER_PHOTO_SUCCESS: {
      return state.set('showPeerPhoto', action.data.showPeerPhoto);
    }

    case types.ADD_PEER_USER_CALL_INFO_SUCCESS: {
      return state.set('user', action.data);
    }

    case types.SET_PEER_PHOTO_SUCCESS: {
      return state.set('peerPhoto', action.data.peerPhoto);
    }

    case types.CHANGE_STATUS_INCOMINGCALL: {
      state = state.set('callFrom', action.data.callFrom);
      return state.set('callModal', action.data.callModal);
    }

    case types.END_CALL_SUCCESS: {
      return state
        .set('callWindow', '')
        .set('callModal', '')
        .set('showPeerPhoto', false)
        .set('showUserPhoto', false)
        .set('peerSrc', null)
        .setIn(['callInfo', 'accepted'], false)
        .setIn(['callInfo', 'watchOnly'], false)
        .set('callState', CALL_STATE.IDLE)
        .set('requestType', '')
        .set('friendID', '')
        .set('interruptID', '')
        .set('localSrc', null);
    }

    case types.UPDATE_INTERRUPTID: {
      return state.set('interruptID', action.data);
    }

    case types.ACCEPT_CALL_SUCCESS: {
      console.log(action)
      return state.setIn(['callInfo', 'accepted'], true).setIn(['callInfo', 'watchOnly'], !!action?.data?.watchOnly).set('callState', CALL_STATE.IN_CALL);
    }
    case types.GET_REQUEST_SUCCESS: {
      if (!state.friendID || (state.friendID && state.friendID === action.message.from)) {
        state = state.set('friendID', action.message.from).set('preFriendID', action.message.from);
        // console.log('preFriendID', action.message.from);
      } else {
        state = state.set('interruptID', action.message.from);
      }
      let data = action.message?.body?.data?.data || action.message?.body?.data || action.message.data
      let requestType = action.message.requestType || action.message?.body?.data?.requestType
      state = state.set('data', data);
      return state.set('requestType', requestType);
    }
    case types.CALL_ACTION_SUCCESS: {
      return state.set('requestType', videoRequestType.CALLING);
    }
    case types.VIDEO_CALL_MINIMIZE: {
      state = state.set('minimize', action.data);
      return state;
    }

    case types.USER_LOGOUT_SUCCESS: {
      state = initialState.videoCall;
      return state;
    }

    case types.COUNT_DOWN_OR_RESET_TIME_CALL: {
      return state.set('timeCountReceive', action.data);
    }

    case types.VIDEO_CALL_FULLSCREEN: {
      return state.set('isFullScreen', action.status);
    }

    case types.SET_REQUEST_TYPE_CALL: {
      state = state.set('requestType', 'call');
      return state.set('data', '');
    }

    case types.CALL_STATE_STARTED_BY: {
      return state.set('callStateStartedBy', action.data);
    }

    case types.CLEAN_UP_VIDEO_CALL: {
      state = initialState.videoCall;
      return state;
    }

    default:
      return state;
  }
}
